import { SELECT_MENU } from './types';

export const select = id => ({
	type: SELECT_MENU,
	selected: id,
});
